import React from "react";

export const handleSmoothScroll = (
  e: React.MouseEvent<HTMLAnchorElement>,
  targetId: string,
) => {
  e.preventDefault();
  const element = document.getElementById(targetId);
  if (element) {
    if (targetId === "security") {
      const topOffset = element.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: Math.max(0, topOffset - 100),
        behavior: "smooth"
      });
    } else {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }
};
